import { DataType } from "../../../../form/typings";
import i18n from "../../../i18n";
export default {
    $id: "description",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemName').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        dataItemName: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemCode').toString(),
        },
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        statisticMode: {
            type: DataType.String,
            title: i18n.t('dataitem.SummaryMode').toString(),
            default: "sum",
        },
        format: {
            type: DataType.String,
            title: i18n.t('dataitem.Format1').toString(),
        },
    },
};
